import React from "react";

export default function Footer() {
    return (
        <React.Fragment>
            <footer className="app-footer">
                <div className="container text-center py-3">
                    <small className="copyright">&copy;2021 - {(new Date().getFullYear())} DGBOOK | Réalisé par <span className="sr-only"></span> Digiweb | Conception : <a className="app-link" href="www.digiweb.bj"
                            target="_blank">Digiweb SARL</a></small>

                </div>
            </footer>
        </React.Fragment>
    )
}
